<template>
    <div class="hours-with-customers">
        
        <vue-apex-charts
            :options="chartOptions"
            :series="chartOptions.series"
            :height="chartOptions.chart.height"
            ref="tester"
        />

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['data'],
    data () {
        return {
            chartOptions: {
                series: [],
                labels: [],
                colors: ['#4CAF50', '#FF5252'],
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: (value) => {
                            let percent = Math.round((value / this.data.hours_total) * 100)
                            return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return this.$options.filters.rounded(val) + ' %'
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false
                                /* value: {
                                    formatter: (value) => {
                                        let percent = Math.round((value / this.total) * 100)
                                        return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                                    }
                                } */
                            }
                        }
                    }
                }
            }
        }
    },
    created () {
        this.setData()
    },
    methods: {
        setData () {
            this.chartOptions.labels = this.data.efficiency_series.labels
            this.chartOptions.series = this.data.efficiency_series.series
        }
    },
    watch: {
        componentData: function () {
            this.setData()
        }
    },
    components: {
        VueApexCharts
    },
    computed: {
        componentData () {
            return this.data
        }
    }
}
</script>



// WEBPACK FOOTER //
// hoursWithCustomers.vue?1fd3a93c